module.exports = __webpack_public_path__ + "img/image.bddbf3e0.svg";